<div class="popup-template notification-popup">
  <div class="content popup">
    <h5 class="popup-title">
      {{ getTitle('errorwarningspopuptitlewarnings' | translate, 'errorwarningspopuptitleerrors' | translate) }}
    </h5>
    <div class="popup-content custom-scroll">
      @if (options?.showNoWarningsText || data?.warnings?.length > 0) {
        <div class="popup-section warnings">
          @switch (source?.type) {
            @case ('resource') {
              <app-resource-warnings [warnings]="data?.warnings" [source]="source"></app-resource-warnings>
            }
            @default {
              <app-default-warnings [warnings]="data?.warnings"></app-default-warnings>
            }
          }
        </div>
      }

      @if (data?.errors?.length > 0) {
        <div class="popup-section errors">
          @for (errorItem of data.errors; track $index) {
            <p class="error-item">
              <span>
                {{
                  errorItem.message?.isTranslatable ? (errorItem.message?.value | translate) : errorItem.message.value
                }}
              </span>
            </p>
          }
        </div>
      }
    </div>
  </div>
  <div class="buttons">
    <button class="btn btn-outline-primary cancel" (click)="onCancel()">{{ 'generalcancel' | translate }}</button>

    @if (!options?.readonly && !data?.errors?.length) {
      <app-button
        class="accept"
        classNames="btn-primary"
        labelKey="generalcontinue"
        [isLoading]="isLoading"
        (clicked)="onContinue()"
      ></app-button>
    }
  </div>
</div>
